import { Injectable } from '@angular/core';
import { DataService } from './data.service';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoaderHandlerService {
  outgoingServicesCount = 0;
  private loaderEventSource = new Subject<boolean>();
  handler$ = this.loaderEventSource.asObservable();

  constructor(private dataService: DataService) { }

  toggleLoader(serviceFlag: number) {
    switch (serviceFlag) {
      case 0:
        // service returned response
        this.outgoingServicesCount -= 1;
        if (this.outgoingServicesCount <= 0) {
          this.outgoingServicesCount = 0;
          this.loaderEventSource.next(false);
        }
        break;
      case 1:
        // service called
        this.outgoingServicesCount += 1;
        this.loaderEventSource.next(true);
        break;
    }
  }

}
